<template>
  <div class="home">
      <Admin class="marginal" ></Admin>
  </div>
</template>

<script>
import Admin from '@/components/Admin.vue';
export default {
  name: 'AdminPage',
  components: {
    Admin
  }
}
</script>